import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtistProfile = (artist) => {
  //artist --> artist ID
  return axios.get(URL_PREFIX + '/artist-profiles/' + artist + '/')
}

export const patchArtistProfile = (artist, param) => {
  //artist --> artist ID
  return axios.patch(URL_PREFIX + '/artist-profiles/' + artist + '/', param)
}
